<div style="color: #3f3f3f;">
  <h4 style="text-align: center;
  margin: auto;
  font-size: 24px;">NOTICE</h4>

  <div style="margin-top: 10px;"><p style="font-size: 18px;
    font-weight: 600;">Please check the following missing info for this final inspection: </p></div>
  <div style="line-height: 0.7em;padding: 0.5em 0.5em 0.5em 0.5em;overflow-y: auto; max-height: 60vh;">
    <p *ngFor="let item of lines" style="font-size: 12px;
    font-weight: bold;
    letter-spacing: 0.3px;
    text-align: left;">
      {{item}}
    </p>
  </div>
  <!--<p style="white-space: pre-line;">{{warning}}</p> -->

  <div style="display: flex;
  justify-content: space-around;margin-top: 1em;">
    <button mat-button [mat-dialog-close]="1" style="background-color: #eeeeee;
    color: #3f3f3f;
    letter-spacing: 0.5px;
    border: 1px solid #d4d4d4;
    height: 50px;">Close Anyway</button>


    <button mat-button [mat-dialog-close]="2" style="background-color: #3f3f3f;
    color: #eeeeee;
    letter-spacing: 0.5px;
    height: 50px;">Back to Form</button>
  </div>
</div>

